import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import * as moment from "moment";

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.css']
})
export class AppFooterComponent implements OnInit {
  contactEmail = 'team.one@jpl.nasa.gov';
  build: any = {};
  constructor(private http: HttpClient) {
  }

  ngOnInit(): void {
    this.http.get('./version.json').subscribe(data => {
      this.build = data;
    });
  }

  formatBuildTime() {
    var mom = new Date(this.build.timestamp);
    if (
      this.build.timestamp !== undefined &&
      this.build.timestamp !== "{timestamp}"
    ) {
      var mom2 = this.build.timestamp.substr(
        0,
        this.build.timestamp.length - 4
      );
      return moment(mom2).format("MMMM Do YYYY");
    }
    return moment(mom).format("MMMM Do YYYY");
  }
}
